"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldMileage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const FullWidthInputNumber = (0, styled_components_1.default)(antd_1.InputNumber) `
	width: 100%;
`;
const OfferFieldMileage = ({ name, label, rules, listName, ...otherProps }) => {
    const hasListName = typeof listName === 'number' || typeof listName === 'string';
    const fieldName = hasListName ? [listName, name] : name;
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: fieldName, label: label, rules: rules, children: (0, jsx_runtime_1.jsx)(FullWidthInputNumber, { ...otherProps }) }));
};
exports.OfferFieldMileage = OfferFieldMileage;
